import { Button, Grid } from "@material-ui/core";
import { useState } from "react";
import {
  ApartmentOnboarding,
  ApartmentOnboardingDocsAndContractsDoc,
  InternalOnboardingTimeline,
} from "../../../graphql/models";
import { i18nForFields } from "../../../i18n";
import {
  AttachmentsListWithTitle,
  AttachmentWithTitleItem,
} from "../attachments_list_with_title";
import { OnboardingTimelineComponent } from "../onboarding_timeline";
import { I18NMarkdownEditor } from "../i18n_markdown_editor";

export interface ApartmentOnboardingProps {
  onboarding: ApartmentOnboarding;
  onChange: (item: ApartmentOnboarding) => void;
}

export function ApartmentOnboardingComponent(props: ApartmentOnboardingProps) {
  const { onboarding } = props;
  const { docsAndContracts } = onboarding;

  const [i18nFields, setI18nFields] = useState<
    Partial<i18nForFields<"description">>
  >(docsAndContracts?.i18n ?? {});

  let docsInitialValue: AttachmentWithTitleItem[] = [];
  if (docsAndContracts) {
    const docsValue = docsAndContracts.docs ?? [];
    docsInitialValue = docsValue.map(
      (source: ApartmentOnboardingDocsAndContractsDoc) => {
        return { ...source };
      }
    );
  }
  const [docs, setDocs] = useState<AttachmentWithTitleItem[]>(docsInitialValue);
  const [timeline, setTimeline] = useState<InternalOnboardingTimeline[]>(
    docsAndContracts?.timeline ?? []
  );

  const confirmChanges = () => {
    const onboarding: ApartmentOnboarding = {
      docsAndContracts: {
        i18n: i18nFields,
        description: i18nFields.description_it ?? "",
        docs: docs.map((item: AttachmentWithTitleItem) => {
          return { ...item, title: item.i18n.title_it };
        }),
        timeline: timeline.map((item) => {
          let v = { ...item };
          delete v["isNewRow"];
          return v;
        }),
      },
    };
    props.onChange(onboarding);
  };

  return (
    <>
      <Grid item xs={12}>
        <I18NMarkdownEditor
          label="Descrizione pagina introduttiva"
          i18nFieldName="description"
          value={i18nFields}
          onChange={setI18nFields}
        ></I18NMarkdownEditor>
      </Grid>
      <Grid item xs={12}>
        <AttachmentsListWithTitle
          title="Sezione Allegati"
          items={docs}
          onUpdated={(v) => setDocs(v)}
        />
      </Grid>
      <Grid item xs={12}>
        <OnboardingTimelineComponent
          value={timeline}
          onChange={setTimeline}
        ></OnboardingTimelineComponent>
      </Grid>
      <Grid item xs={12}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={confirmChanges}
          style={{ marginTop: "1rem" }}
        >
          Conferma le modifiche di questa sezione
        </Button>
      </Grid>
    </>
  );
}
